<div class="flex-container">
    <input 
        #search
        type="text"
        class="search" 
        [(ngModel)]="value" 
        (ngModelChange)="handleChange();" 
        (keyup)="onKey($event);" >
    <button mat-raised-button class="cb-button" (click)="onButton()"> 
        <mat-icon class="custom-icon">expand_more</mat-icon> 
    </button>
</div>

<div class="data-container" [ngStyle]="allowDropdownStretch ? {'width': 'unset'} : {'width': '205px'}" *ngIf="showDropDown && !disabled">
    <div *ngFor="let item of filteredOptions" class="option" (click)="dropDownSelect(item);" >{{item.value}}</div>
    <div class="empty-option" *ngIf="filteredOptions.length == 0;">{{input}}</div>
</div>
